import { Grid, makeStyles, Paper } from "@material-ui/core";
import { Field, FieldProvider, Text, TextArea, Numeric, DatePicker, IConditionParameters, Checkbox, Condition } from "@ngt/forms";
import { ConditionMode } from '@ngt/forms-core';
import { FC } from "react";
import * as Dtos from '../../api/dtos';
import Attachment from "../../components/Attachment";
import FormContainer from "../../components/layouts/FormContainer";
import { fieldMargin, gridFieldMargin } from "../../constants/forms";
interface INewVendorRequestProps {}
const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2, 2, 2, 2),
    margin: theme.spacing(2, 0, 2, 0)
  },
  gridItemCenter: {
    display: 'flex',
    alignItems: 'center'
  }
}));
const valuesSubscription = {
  values: true
};
const abnProvided = ({
  formState
}: IConditionParameters<Dtos.NewVendorRequest>) => {
  return formState?.values.abnNotProvided !== true;
};
const NewVendorRequest: FC<INewVendorRequestProps> = () => {
  const classes = useStyles();
  return <FormContainer maxWidth="md" formType={Dtos.NewVendorRequest} data-sentry-element="FormContainer" data-sentry-component="NewVendorRequest" data-sentry-source-file="NewVendorRequest.tsx">
            {/* FieldProvider is placed here so form level errors will appear on the form. */}
            <FieldProvider name="id" data-sentry-element="FieldProvider" data-sentry-source-file="NewVendorRequest.tsx" />
            <Paper className={classes.paper} data-sentry-element="Paper" data-sentry-source-file="NewVendorRequest.tsx">
                <Field name="name" component={Text} margin={fieldMargin} data-sentry-element="Field" data-sentry-source-file="NewVendorRequest.tsx" />
                <Field name="address" component={TextArea} rows={2} rowsMax={2} margin={fieldMargin} data-sentry-element="Field" data-sentry-source-file="NewVendorRequest.tsx" />
                <Field name="contactName" component={Text} margin={fieldMargin} data-sentry-element="Field" data-sentry-source-file="NewVendorRequest.tsx" />
                <Field name="phone" component={Text} margin={fieldMargin} data-sentry-element="Field" data-sentry-source-file="NewVendorRequest.tsx" />
                <Field name="email" component={Text} margin={fieldMargin} data-sentry-element="Field" data-sentry-source-file="NewVendorRequest.tsx" />
                <Grid container spacing={6} justify="space-between" data-sentry-element="Grid" data-sentry-source-file="NewVendorRequest.tsx">
                    <Grid item xs={12} sm={8} md={9} data-sentry-element="Grid" data-sentry-source-file="NewVendorRequest.tsx">
                        <Condition type={Dtos.NewVendorRequest} mode={ConditionMode.Enable} condition={abnProvided} subscription={valuesSubscription} registerParent data-sentry-element="Condition" data-sentry-source-file="NewVendorRequest.tsx">
                            <Field name="abn" component={Numeric} margin={fieldMargin} inputProps={{
              maxLength: 11
            }} data-sentry-element="Field" data-sentry-source-file="NewVendorRequest.tsx" />
                        </Condition>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3} className={classes.gridItemCenter} data-sentry-element="Grid" data-sentry-source-file="NewVendorRequest.tsx">
                        <Field name="abnNotProvided" component={Checkbox} inputProps={{
            maxLength: 11
          }} data-sentry-element="Field" data-sentry-source-file="NewVendorRequest.tsx" />
                    </Grid>
                </Grid>
                <Attachment data-sentry-element="Attachment" data-sentry-source-file="NewVendorRequest.tsx" />
                <Grid container spacing={2} data-sentry-element="Grid" data-sentry-source-file="NewVendorRequest.tsx">
                    <Grid item xs={12} md={8} data-sentry-element="Grid" data-sentry-source-file="NewVendorRequest.tsx">
                        <Field name="enteredBy" component={Text} margin={gridFieldMargin} disabled data-sentry-element="Field" data-sentry-source-file="NewVendorRequest.tsx" />
                    </Grid>
                    <Grid item xs={12} md={4} data-sentry-element="Grid" data-sentry-source-file="NewVendorRequest.tsx">
                        <Field name="enteredDate" component={DatePicker} margin={gridFieldMargin} disabled data-sentry-element="Field" data-sentry-source-file="NewVendorRequest.tsx" />
                    </Grid>
                </Grid>
            </Paper>
        </FormContainer>;
};
export default NewVendorRequest;